import script from "./AddNewTagAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddNewTagAtom.vue?vue&type=script&setup=true&lang=ts"

import "./AddNewTagAtom.vue?vue&type=style&index=0&id=093bf696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093bf696"]])

export default __exports__